var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 48 48",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    transform: "translate(-575.129 -373.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    d: "M604.7,396h17c0.8,0,1.4-0.6,1.4-1.4l0,0c0-11.7-9.5-21.2-21.2-21.2c-0.8,0-1.4,0.6-1.4,1.4v17 C600.5,394.1,602.4,396,604.7,396z M603.3,376.2c9,0.7,16.2,7.9,16.9,16.9h-15.5c-0.8,0-1.4-0.6-1.4-1.4V376.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    d: "M622.2,403.1c-0.7-0.3-1.5,0.1-1.8,0.8c0,0,0,0,0,0c-3,8.7-11.2,14.6-20.5,14.6c-0.4,0-0.9,0-1.3,0 c-11.2-0.7-20.1-9.7-20.6-20.9c-0.5-9.6,5.4-18.4,14.5-21.6c0.7-0.3,1.1-1.1,0.9-1.8c-0.3-0.7-1.1-1.1-1.8-0.9 c-10.2,3.6-16.9,13.4-16.4,24.3c0.6,12.6,10.6,22.8,23.2,23.6h1.6c10.4,0,19.7-6.6,23.1-16.4C623.3,404.2,622.9,403.4,622.2,403.1z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.6654b7406f83b66485593a2ba0858d13.svg";
export { ForwardRef as ReactComponent };